import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useMakeLlmPrivate = () => {
  const {
    data: isMade,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const makeLlmPrivate = async (llmName: string) => {
    await call(`/admin/llm/${llmName}/public`, "DELETE");
  };

  return {
    makeLlmPrivate,
    isMade,
    isLoading,
    isFailed,
  };
};
